<template>
<div style="min-width:950px">
  <div id="certificate" class="main-container">
    <img src="../../../../assets/nimasalogo.png" style="padding: 2em; max-height: 600px; max-width: 600px; margin: 7em auto 0em;" alt="coat of arms" class="image">
    <div ref="Certificate" class="dt-container">
      <h1 class="approved-stamp">Approved</h1>

      <div class="dt-header">
        <img src="../../../../assets/nimasa-logo.png" style="padding: 1em">
        <div>
          <h1 class="main-header">DANGEROUS GOODS SHIPMENT CERTIFICATE</h1>

          <p>
            This is to certify that
          </p>
          <h2 class="name-tag">{{ data.shipper_name }}</h2>
          <p class="c-address">
            {{ data.shipper_address }}
            <br>has complied with the requirements of the IMDG Code for the carriage of Dangerous Goods at sea in Nigeria
          </p>

          <p class="table-heading">This Certificate is valid for the carriage of the following items:</p>

          <div class="table">
            <table>
              <thead>
                <tr>
                  <th>UN Number</th>
                  <th>Proper Shipping Name</th>
                  <th>Gross Mass (kg)</th>
                  <th>Class</th>
                </tr>
              </thead>

              <tbody v-for="item in data.dangerousGoods" :key="item.id">
                <tr>
                  <td>{{ item.dangerous_good_info.un_number }}</td>
                  <td>{{ item.dangerous_good_info.proper_shipping_name }}</td>
                  <td>{{ item.total_gross_mass }}</td>
                  <td>{{item.dangerous_good_info.imo_class}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="ports">
            <div
              class="has-text-weight-bold"
              v-if="data.port_of_loading_id"
            >Port Of Loading: {{port_of_loading}}</div>
            <div
              class="has-text-weight-bold"
              v-if="data.port_of_loading"
            >Port Of Loading: {{data.port_of_loading}}</div>
            <div
              class="has-text-weight-bold"
              v-if="data.port_of_discharge_id"
            >Port Of Discharge: {{port_of_discharge}}</div>
          </div>

          <div v-if="activityData" class="certificate-listing">
            <div>
              <p>
                Approval Date
              </p>
              <h5 v-if="activityData" class="has-text-weight-bold has-padding-top-10">{{ activityData[2].action_date | moment("DD/MM/YYYY") }}</h5>
            </div>
            <div style="border-bottom: none"></div>
            <div>
              <p>
                Signature
              </p>
              <h5 class="has-text-weight-bold has-padding-top-10" > for DG NIMASA - {{ activityData[2].causer.full_name }}</h5>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </div>
  <button
        @click="printCertificate"
        type="button"
        class="button is-primary has-margin-top-30 has-width-350"
      >Print</button>
  </div>
</template>

<script>

import GetActivityHistoryQuery from "@/modules/commonModule/api/graphql/queries/GetActivityHistory.gql";

export default {
  name: "Certificate",
  components: {},
  props: {
    data: Object,
    print: Boolean
  },
  data() {
    return {
      port_of_discharge: "",
      port_of_loading: "",
      isLoading: false,
      activityData: null,
    };
  },
  mounted() {
    this.port_of_discharge = this.getPortOfDischarge();
    this.getActivityHistoryFromAPI();
    if (this.data.port_of_loading_id) {
      this.port_of_loading = this.getPortOfLoading();
    }
  },
  methods: {
    getPortOfDischarge() {
      return this.$store.getters.getPortByID(
        this.data.port_of_discharge_id.toString()
      ).name;
    },
    getPortOfLoading() {
      return this.$store.getters.getPortByID(
        this.data.port_of_loading_id.toString()
      ).name;
    },
    printCertificate() {
      const styles = `* {
  padding: 0px;
  margin: 0px;
}
@page {size: landscape; margin: 0;}
.main-container {
  position: relative;
  width: 100%;
  padding: 10px;
}

.image{
  opacity: .15;
  left: 40% !important;
  margin-left: 200px !important;
  margin-top: 170px !important;
}
.moveLeft {
  text-align: left;
  font-weight: bold;
  width: 70%;
  margin: 5px auto;
}
.table-heading {
  margin-top: 40px;
}
.dt-container {
  text-align: center;
  top: 5%;
  left: 4%;
  width: 90%;
  color: black;
  position: absolute;
  margin-top: 40px;
  overflow: hidden;
  border: 10px dashed #2ca8e0;
}
.main-header {
  font-size: 30px;
  font-weight: bolder;
  margin: 1em 0em .5em;
}
.name-tag {
  font-size: 25px;
  font-weight: bolder;
}
.dt-container p {
  font-size: 14px;
}
.dt-container span {
  font-weight: bolder;
  font-size: 12px;
  color: grey;
  opacity: 0.8;
}
.c-address {
  font-weight: bold;
}
.dt-container h3 {
  padding: 20px;
  color: #3c5081;
  font-weight: bold;
}
.certificate-listing {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 20px;
  width: 80%;
  margin: 1.5em auto 0em;
}
.certificate-listing div {
  padding: 10px;
  border-bottom: 1px solid black;
  margin-bottom: 20px;
}
.certificate-listing div {
  font-size: 12px;
  line-height: 15px;
}
.ports{
  margin-top: 1em;
}
.table {
  width: 70%;
  margin: 0px auto;
  border: 2px solid #3c5081;
  border-radius: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  color: black;
}
table {
  width: 100%;
  font-size: 14px;
  text-align: center;
}
table td {
  border-top: 1px solid #3c5081;
  padding: 12px;
  margin: 0px;
}
table th {
  padding: 12px;
  margin: 0px;
}
.approved-stamp {
   position: absolute;
    color: green;
    padding: 10px 40px;
    -webkit-transform: rotate(-20deg);
    transform: rotate(-20deg);
    top: 55px;
    left: 50px;
    font-weight: bolder;
    border: 3px solid green;
    border-radius: 10px;
    font-size: 25px;
    text-transform: uppercase;
}`;
      const element = document.getElementById("certificate");
      const mywindow = window.open(
        "",
        "Print Certificate",
        "height=600,width=950"
      );
      mywindow.document.write(`
            <html>
              <head>
                <title>${document.title}</title>
                <style>${styles}</style>
              </head>
              <body>
                ${element.innerHTML}
              </body>
            </html>
          `);
      mywindow.focus();
      setTimeout(() => {
        mywindow.document.close();
        mywindow.focus();
        mywindow.print();
        mywindow.close();
      }, 1000);

      return true;
    },
    getActivityHistoryFromAPI: function() {
      this.isLoading = true;

      this.$apollo
        .query({
          query: GetActivityHistoryQuery,
          variables: {
            shipping_request_id: this.data.id
          }
        })
        .then(response => {
          const ActivityHistory =
            response.data.GetShippingRequestActivtyHistory;

          this.activityData = ActivityHistory;
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "An error occured trying to retrieve data",
            type: "is-danger"
          });
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
<style scoped>
* {
  padding: 0px;
  margin: 0px;
}
.main-container {
  position: relative;
  width: 90%;
  min-height: 650px;

  border: 8px solid #3c5081;
  /* font-family: arial; */
  margin: 0 auto;
}

.image {
  opacity: 0.1;
  max-width: 600px;
}
.moveLeft {
  text-align: left;
  font-weight: bold;
  width: 70%;
  margin: 5px auto;
}
.dt-container {
  text-align: center;
  top: 0;
  /* min-width: 900px; */
  width: 100%;
  /* margin: 0px auto; */
  color: black;
  position: absolute;
  margin-top: 40px;
  /* margin-bottom: 40px; */
  overflow: hidden;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.main-header {
  font-size: 30px;
  font-weight: bolder;
}
.name-tag {
  font-size: 25px;
  font-weight: bolder;
}
.dt-container p {
  font-size: 14px;
}
.dt-container span {
  font-weight: bolder;
  font-size: 12px;
  color: grey;
  opacity: 0.8;
}
.c-address {
  font-weight: bold;
}
.dt-container h3 {
  padding: 20px;
  color: #3c5081;
  font-weight: bold;
}
.certificate-listing {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 20px;
  width: 80%;
  margin: 0px auto;
}
.certificate-listing div {
  padding: 10px;
  border-bottom: 1px solid black;
  margin-bottom: 20px;
}
.certificate-listing div {
  font-size: 12px;
  line-height: 15px;
}
.table {
  width: 70%;
  margin: 0px auto;
  border: 2px solid #3c5081;
  border-radius: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  color: black;
}
table {
  width: 100%;
  font-size: 14px;
  text-align: center;
}
table td {
  border-top: 1px solid #3c5081;
  padding: 12px;
  margin: 0px;
}
table th {
  padding: 12px;
  margin: 0px;
}
.approved-stamp {
  position: absolute;
  color: green;
  padding: 10px 40px;
  -webkit-transform: rotate(-20deg);
  transform: rotate(-20deg);
  top: 35px;
  left: 18px;
  font-weight: bolder;
  border: 3px solid green;
  border-radius: 10px;
  font-size: 25px;
  text-transform: uppercase;
}
.coat-of-arm {
  width: 70%;
  position: absolute;
  top: 100px;
  z-index: -200;
  opacity: 0.05;
}
.button{
  left: 32%;
}
</style>
